export const dirname = () => {
	return process.env && process.env.NODE_ENV === "development" ? "" : "/solar";
};

export const realmName = () => {
	return process.env && process.env.NODE_ENV === "development"
		? "GreenYellow-prod"
		: "GreenYellow-prod";
};

export const clientID = () => {
	return process.env && process.env.NODE_ENV === "development"
		// ? "52b03e6b-f088-4801-b782-342e1e9f25ab"
		? "5835220c-b8bc-4f55-82c9-74cd54559615"
		: "5835220c-b8bc-4f55-82c9-74cd54559615";
};
